export const TTV_LAUNCH_AFFILIATES: Readonly<
  Record<string, readonly string[]>
> = {
  ref: [
    "bishu2",
    "juany40",
    "juanu5",
    "mha",
    "lanewoodstudios",
    "jsewell",
    "DARKLOUD",
    "sporblix",
    "Lasha40",
    "spinlight",
    "edward5m",
  ],
  from: ["mykah", "blueinfinity", "DannyNagy", "Ozgun", "RoyTsouk"],
  key: ["select"],
};
export const TTV_LAUNCH_AFFILIATE_STORAGE_KEY = "ttv-launch-affiliate";
